import { Checkbox, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAssignTimecardHours extends Layout {
    checkboxAssignHoursByPayFrequency: Checkbox;
    labelDescription: Label;
    labelHolidayHours: Label;
    labelRegularHours: Label;
    textboxHolidayDefaultHours: Textbox;
}
